export default "__VITE_ASSET__BHj83PXB__"